import type { DueTone } from '@/lib/dates/due-summary';
import type { TaskPriority, TaskStatus } from '@/data/db';

export const STATUS_LABELS: Record<TaskStatus, string> = {
  new: '新建立',
  in_progress: '處理中',
  waiting: '等待回覆',
  resolved: '已解決',
  closed: '已結案',
  cancelled: '已取消',
};

export const PRIORITY_LABELS: Record<TaskPriority, string> = {
  normal: '一般',
  important: '重要',
  urgent: '緊急',
};

/** 重要程度不只用顏色表示，另有文字標籤（spec 25.1）。 */
export const PRIORITY_TONES: Record<TaskPriority, 'neutral' | 'warning' | 'danger'> = {
  normal: 'neutral',
  important: 'warning',
  urgent: 'danger',
};

const DUE_TONE_CLASSES: Record<DueTone, string> = {
  today: 'text-warning',
  upcoming: 'text-text-muted',
  overdue: 'text-danger',
  waiting: 'text-warning',
};

export function dueToneClass(tone: DueTone): string {
  return DUE_TONE_CLASSES[tone];
}
